/** Bump manually when persisted query shapes change so old cache is discarded on deploy. */
export const QUERY_CACHE_VERSION = 1;

/** Injected at build time via vite.config — git SHA or build timestamp. */
export const APP_BUILD_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';

// Not the build SHA. With it, every app update threw away every downloaded festival map and
// set times - an update installing itself overnight left people at the gates with nothing
// (2026-09-25 audit). Bump QUERY_CACHE_VERSION instead when a persisted query's shape changes.
export const QUERY_CACHE_BUSTER = `${QUERY_CACHE_VERSION}`;
